export { default } from './RibbonCheckOne'
